import styled from 'styled-components';
import { Typography } from '@mui/material';
import { ColorToken } from '@elementary/common-ui/style/types';
import {
  fontSize,
  fontWeight,
  getColor,
} from '@elementary/common-ui/style/utils';
import ContentWithLabel, { Variant } from './ContentWithLabel';

const ValueWrapper = styled(Typography)<{
  $variant: Variant;
  $valueColor?: ColorToken;
}>`
  font-size: ${({ $variant }) =>
    $variant === 'big' ? '32px' : fontSize('xxxl')};
  font-weight: ${fontWeight('medium')};
  color: ${({ $valueColor, theme }) =>
    $valueColor ? getColor(theme, $valueColor) : theme.palette.content.primary};
`;

type Props = {
  title?: string;
  variant?: Variant;
  value: string;
  valueColor?: ColorToken;
  titleLink?: string;
};

const TextWithLabel = ({
  title = '',
  variant = 'regular',
  value,
  valueColor,
  titleLink,
}: Props) => (
  <ContentWithLabel title={title} link={titleLink}>
    <ValueWrapper $variant={variant} $valueColor={valueColor}>
      {value}
    </ValueWrapper>
  </ContentWithLabel>
);
export default TextWithLabel;
